import { useEffect } from "react";
import { useTranslation } from "react-i18next";

// Built with REACT_APP_STAGING=true (docker-compose passes STAGING through
// as a build arg): a bar on every screen, login included, and a "STAGING"
// tab title, so nobody mistakes the staging server for production.
// Renders nothing in a normal build.
export const STAGING_BUILD = process.env.REACT_APP_STAGING === "true";

export default function StagingBanner({ enabled = STAGING_BUILD }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!enabled || document.title.startsWith("STAGING")) return;
    document.title = `STAGING · ${document.title}`;
  }, [enabled]);

  if (!enabled) return null;
  return (
    <div
      role="note"
      data-testid="staging-banner"
      style={{
        backgroundColor: "#b45309",
        color: "#fff",
        textAlign: "center",
        padding: "6px 16px",
        fontSize: "12px",
        fontWeight: "700",
        letterSpacing: "1px",
        lineHeight: 1.4,
      }}
    >
      {t("staging.banner")}
    </div>
  );
}
